export enum KeyCode {
    RIGHT = 39,
    LEFT = 37,
    UP = 38,
    DOWN = 40,
    ESC = 27,
    ENTER = 13,
    BACKSPACE = 8
}